import { defineComponent, onMounted } from 'vue';
import { useTimestampStore } from '@/store/timestamp.store';
import { storeToRefs } from 'pinia';
import { Timer, Clock } from '@element-plus/icons-vue';

export default defineComponent({
  name: 'ReportTimestamp',
  components: { Timer, Clock },

  setup() {
    const timestampStore = useTimestampStore();
    const { timestamp, isTimestampLoading } = storeToRefs(timestampStore);
    const { getReportTimestamp } = timestampStore;

    onMounted(() => {
      getReportTimestamp();
    });

    return {
      timestamp,
      isTimestampLoading,
    };
  },
});
